/* ==========================================================================
   LA LUPA — Cuadros Splash

   La segunda foto de cada ficha es la obra limpia, a 2048 px. La de catalogo
   es un mockup de salon y ahi no hay nada que mirar de cerca; en la obra si:
   la pincelada, la textura del lienzo, la firma de Ebora en la esquina.

   Se arrastra con la mano, como se acerca uno a un cuadro en una sala:
   pulsas, se acerca, y mueves para recorrerlo. Al soltar, vuelve.

   POR QUE NO ES EL ZOOM DE DAWN
   Dawn abre un modal a pantalla completa al hacer clic. Eso saca al cliente
   de la ficha, y en movil se come la pantalla entera. Aqui el detalle se ve
   sin salir de donde estabas, que es lo que se pidio.

   DE DONDE SALE LA IMAGEN GRANDE
   El srcset del tema ya trae la obra hasta 2048 px. La lupa carga esa version
   aparte y solo cuando hace falta (al primer contacto), para no penalizar la
   carga de la ficha con una imagen que quiza nadie amplie.
   ========================================================================== */
(function () {
  'use strict';

  var AUMENTO = 2.6;          // 2048 px sobre ~780 px de hueco: se ve la trama
  var UMBRAL_MOVIL = 750;

  function urlGrande(img) {
    /* El src del tema pide 1445 px. Para la lupa se pide 2048, que es justo
       lo que mide la obra: pedir mas seria escalar hacia arriba. */
    var base = img.currentSrc || img.src || '';
    if (!base) return '';
    return base.replace(/([?&])width=\d+/, '$1width=2048');
  }

  function montar(img) {
    if (img.dataset.lupaLista === '1') return;
    // dentro del modal a pantalla completa la lupa sobra: ahi ya se ve grande
    if (img.closest('.product-media-modal')) return;
    img.dataset.lupaLista = '1';

    var marco = document.createElement('span');
    marco.className = 'lupa';
    img.parentNode.insertBefore(marco, img);
    marco.appendChild(img);

    var pista = document.createElement('span');
    pista.className = 'lupa__pista';
    pista.textContent = 'Arrastra para ver el detalle';
    marco.appendChild(pista);

    var grande = null;
    var activa = false;

    function precargar() {
      if (grande) return;
      var u = urlGrande(img);
      if (!u) return;
      grande = new Image();
      grande.className = 'lupa__grande';
      grande.alt = '';
      grande.setAttribute('aria-hidden', 'true');
      grande.src = u;
      marco.appendChild(grande);
    }

    function coloca(e) {
      var r = marco.getBoundingClientRect();
      var p = e.touches ? e.touches[0] : e;
      // 0..1 dentro del marco, acotado para que no se despegue por los bordes
      var x = Math.min(Math.max((p.clientX - r.left) / r.width, 0), 1);
      var y = Math.min(Math.max((p.clientY - r.top) / r.height, 0), 1);
      if (grande) {
        grande.style.transformOrigin = (x * 100) + '% ' + (y * 100) + '%';
        grande.style.transform = 'scale(' + AUMENTO + ')';
      }
    }

    function abrir(e) {
      precargar();
      if (!grande) return;
      activa = true;
      marco.classList.add('lupa--activa');
      coloca(e);
    }

    function cerrar() {
      if (!activa) return;
      activa = false;
      marco.classList.remove('lupa--activa');
      if (grande) grande.style.transform = '';
    }

    marco.addEventListener('mouseenter', precargar);
    marco.addEventListener('mousedown', function (e) {
      e.preventDefault();   // si no, el navegador arrastra la imagen como fichero
      abrir(e);
    });
    marco.addEventListener('mousemove', function (e) {
      if (activa) coloca(e);
    });
    document.addEventListener('mouseup', cerrar);
    marco.addEventListener('mouseleave', cerrar);

    /* En movil no hay raton que sostener: el dedo ya arrastra la pagina. Se
       usa touch con passive:false para poder quedarnos el gesto solo mientras
       la lupa esta abierta, y devolverlo en cuanto se levanta el dedo. */
    marco.addEventListener('touchstart', function (e) {
      abrir(e);
    }, { passive: true });
    marco.addEventListener('touchmove', function (e) {
      if (!activa) return;
      e.preventDefault();
      coloca(e);
    }, { passive: false });
    marco.addEventListener('touchend', cerrar);
    marco.addEventListener('touchcancel', cerrar);

    /* Teclado: quien no pueda arrastrar tambien tiene que poder acercarse.
       Enter o espacio fijan la lupa en el centro y las flechas la mueven. */
    marco.tabIndex = 0;
    marco.setAttribute('role', 'button');
    marco.setAttribute('aria-label', 'Ampliar la obra para ver el detalle');
    var kx = 0.5, ky = 0.5;
    function pinta() {
      if (!grande) return;
      grande.style.transformOrigin = (kx * 100) + '% ' + (ky * 100) + '%';
      grande.style.transform = 'scale(' + AUMENTO + ')';
    }
    marco.addEventListener('keydown', function (e) {
      var flechas = { ArrowLeft: [-0.08, 0], ArrowRight: [0.08, 0],
                      ArrowUp: [0, -0.08], ArrowDown: [0, 0.08] };
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        if (activa) { cerrar(); return; }
        precargar();
        if (!grande) return;
        activa = true;
        kx = 0.5; ky = 0.5;
        marco.classList.add('lupa--activa');
        pinta();
      } else if (activa && flechas[e.key]) {
        e.preventDefault();
        kx = Math.min(Math.max(kx + flechas[e.key][0], 0), 1);
        ky = Math.min(Math.max(ky + flechas[e.key][1], 0), 1);
        pinta();
      } else if (e.key === 'Escape') {
        cerrar();
      }
    });
  }

  function arrancar() {
    /* Dos sitios, dos formas de marcarlo: en la galeria la marca va en el
       contenedor (ahi la imagen la escribe `image_tag` y no admite atributos
       con guiones), y en el modal va en la propia etiqueta. */
    document.querySelectorAll('img[data-obra-limpia]').forEach(montar);
    document.querySelectorAll('[data-obra-limpia] img').forEach(montar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', arrancar);
  } else {
    arrancar();
  }

  // la galeria de Dawn cambia de imagen al elegir variante: puede llegar tarde
  document.addEventListener('shopify:section:load', arrancar);
  window.addEventListener('load', arrancar);
})();
